/* import __COLOCATED_TEMPLATE__ from './project.hbs'; */
import LSGModalBase from '../lsg/lsg-modal-dialog-base';
import { closeModal, showNextModal } from "sh-www/utils/modal-controls";

export default LSGModalBase.extend({
  /** @inheritDoc */
  propertyDefaults: {
    projectDigest: null,

    isAddLinkToPublishedProject: false,

    isAddingMissingProjectInfo: false,

    addProjectDigestCallback: () => {},

    removeProjectDigestCallback: () => {},
  },

  /** @inheritDoc */
  actions: {
    handleClose() {
      closeModal(this);
    },

    handleShowDeleteModal(modalData) {
      showNextModal(this, 'confirmation', modalData);
    },

    handleShowVerificationMethodModal(modalData) {
      showNextModal(this, 'work-samples/verification-method', modalData);
    },
  },
});
